import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-home-ten',
    templateUrl: './home-ten.component.html',
    styleUrls: ['./home-ten.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeTenComponent implements OnInit {

  constructor(private viewportScroller: ViewportScroller) {}

  public onClick(elementId: string): void { 
      this.viewportScroller.scrollToAnchor(elementId);
  }

  ngOnInit() {
  }

}
